<template>
  <div v-if="loading">
    <MoonLoader class="loading"></MoonLoader>
  </div>

  <div v-else>
    <card-total>
      <div slot="title">
        <div class="cardCustom__header">
          <div class="cardCustom__header-text">
            <span class="uppercase"> Total Progress </span>
          </div>
          <div class="cardCustom__header-info__item">
            <button
              v-tooltip="{
                content: 'Top 3 Recommendations for your club',
                placement: 'bottom-center',
                classes: ['info'],
              }"
            >
              <i class="fas fa-info-circle" />
            </button>
          </div>
        </div>
      </div>
      <div slot="content">
        <paper-table :data="tableData" :columns="tableColumns" type="hover"> </paper-table>
      </div>
    </card-total>
  </div>
</template>

<script>
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import CardSummary from '@/components/Cards/CardSummary';
import CardTotal from '@/components/Cards/CardTotal';
export default {
  name: 'DashboardElementTotalProgress',
  components: { CardTotal, CardSummary, MoonLoader },
  props: {
    summary: Object,
  },
  data() {
    return {
      loading: false,
      summaryCopy: null,
      categoryCopy: null,
      tableColumns: ['Name', 'Impact', 'Category'],
      tableData: [
        {
          id: 1,
          name: 'ENERGY STAR windows installed',
          impact: 'Low',
        },
      ],
    };
  },
  async mounted() {
    this.loading = true;
    this.loading = false;
  },
  methods: {
    getValueClass() {
      return 'success';
    },
  },
};
</script>

<style scoped></style>
